<template>
	<div>
		<div class="fixed-header-wrapper">
			<!-- 顶部 -->
			<div class="top-bar">
				<div class="container top-bar-flex">
					<div>金试商城系统 PRO - 赋能未来实验室 &nbsp; 订购/客服：<span style="color: #007bff;">021-60889184</span></div>
					<div class="top-actions">
						<span><i class="fas fa-file-invoice"></i><router-link to="/order/all"> 订单查询</router-link></span>
						<span><i class="fas fa-headset"></i> 帮助中心</span>
						<!-- <span><i class="fas fa-globe"></i> English</span> -->
					</div>
				</div>
			</div>

			<!-- 头部 Sticky Header -->
			<header class="sticky-header" :class="{ 'scrolled': isScrolled }">
				<div class="container header-row">
					<a href="#" class="logo">
						<div class="logo-text">
							<el-image :src="src" fit="cover" />

						</div>
					</a>

					<div class="search-group">
						<div class="search-box">
							<el-input v-model="searchQuery" :placeholder="placeholderText" @keydown.enter="handleSearch"
								class="input-with-select" clearable>
								<template #append>
									<el-button :icon="Search" @click="handleSearch">搜 索</el-button>
								</template>
							</el-input>
						</div>
					</div>

					<div class="header-right">
						<el-badge :value="cartCount" class="item" :hidden="cartCount === 0"style="margin-right:10px;">
							<el-button round size="large" @click="goCart" >
								<i class="fas fa-shopping-cart" style="margin-right:5px;"></i>购物车
							</el-button>
						</el-badge>
						<a href="#">
							<el-button type="primary" round size="large">
								<i class="fas fa-home" style="margin-right:5px;"></i>首页
							</el-button>
						</a>
					</div>
				</div>
			</header>
		</div>
		<div class="header-placeholder"></div>
	</div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch } from 'vue';
import { useRouter, useRoute } from "vue-router";
import { useUserStore } from "@/stores/user";
import { storeToRefs } from "pinia";
import { useCategoryStore } from "@/stores/category";
import { Search } from '@element-plus/icons-vue'
import { ElMessage } from "element-plus";
import { useCartStore } from "@/stores/cart";
const userStore = useUserStore();
const categoryStore = useCategoryStore();
const cartStore = useCartStore();

const { userInfo } = storeToRefs(userStore);
const { categoryList } = storeToRefs(categoryStore);
const router = useRouter();
const src = ref(require('../../../../assets/images/login/logo_nav.png'))

const searchQuery = ref("");
const placeholderText = ref('正在搜索...');
const cartCount = ref(cartStore.totalNum);
const isScrolled = ref(false);

watch(
	() => cartStore.totalNum,
	(newVal, oldVal) => {
		cartCount.value = newVal;
	},
	{ immediate: true }
)

// 搜索打字机效果
const initTypeEffect = () => {
	const kws = ["中文名", "CAS号", "货号"];
	let kIdx = 0, cIdx = 0, isDel = false;
	let timer;

	const type = () => {
		const cur = kws[kIdx];
		placeholderText.value = isDel ? cur.substring(0, cIdx--) : cur.substring(0, cIdx++);

		let delay = isDel ? 50 : 150;
		if (!isDel && cIdx === cur.length + 1) {
			isDel = true;
			delay = 2000;
		} else if (isDel && cIdx === 0) {
			isDel = false;
			kIdx = (kIdx + 1) % kws.length;
		}

		timer = setTimeout(type, delay);
	};
	type();
	onUnmounted(() => clearTimeout(timer));
};

const handleScroll = () => {
	isScrolled.value = window.scrollY > 50;
};

const handleSearch = () => {
	const dataLength = ref(0)
	if (searchQuery.value) {
		let data = searchQuery.value.split("")
		dataLength.value = data.length
	}
	if (dataLength.value < 2) {
		ElMessage.warning("最少输入两个字符")
		return false
	}

	if (searchQuery.value.trim()) {
		const menu = {
			name: "搜索结果",
			path: `/product/DetailSearch/${searchQuery.value}`,
			meta: { title: `搜索 "${searchQuery.value}"` },
		};
		handleCategoryClick(menu);
		router.push({
			path: `/product/DetailSearch/${searchQuery.value.trim()}`
		})
	}
};

const handleCategoryClick = (...args) => {
	console.log("🚀 ~ handleCategoryClick ~ args:", ...args)
	categoryStore.setCategoryMenu(args);
};

const goCart = () => {
	router.push('/cart/cart');
}

onMounted(() => {
	initTypeEffect();
	window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
	window.removeEventListener('scroll', handleScroll);
});
</script>

<style scoped>
.fixed-header-wrapper {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	z-index: 2000;
	/* 确保层级最高 */
	transition: all 0.3s ease;
}

.header-placeholder {
	height: 124px;
	width: 100%;
}

/* 这里只放 Header 特有的布局样式，通用的 container 等在父组件或全局定义 */
.top-bar {
	background: #fff;
	height: 32px;
	line-height: 32px;
	font-size: 12px;
	color: var(--text-sub);
	border-bottom: 1px solid #e2e8f0;
}

.top-bar-flex {
	display: flex;
	justify-content: space-between;
}

.top-actions span {
	margin-left: 20px;
	cursor: pointer;
	transition: 0.3s;
}

.top-actions span:hover {
	color: var(--tech-blue);
}

.sticky-header {
	background: rgba(255, 255, 255, 0.85);
	backdrop-filter: blur(20px);
	padding: 20px 0;
	position: sticky;
	top: 0;
	z-index: 1000;
	border-bottom: 1px solid rgba(255, 255, 255, 0.5);
	transition: all 0.3s ease;
}

.sticky-header.scrolled {
	padding: 10px 0;
	box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
}

.header-row {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 20px;
}

.logo {
	display: flex;
	align-items: center;
	text-decoration: none;
	cursor: pointer;
}

.logo-text {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	line-height: 1;
	color: #004085;
	max-width: 150px;

}

.logo-en {
	font-family: 'Arial Black', sans-serif;
	font-weight: 900;
	font-size: 24px;
	letter-spacing: -1px;
}

.logo-cn {
	font-family: 'PingFang SC', sans-serif;
	font-weight: bold;
	font-size: 14px;
	letter-spacing: 4px;
	margin-top: 2px;
}

.search-group {
	flex: 1;
	max-width: 600px;
}

.search-box {
	border: 2px solid var(--tech-blue);
	border-radius: 8px;
	overflow: hidden;
	transition: 0.3s;
}

.search-box:focus-within {
	box-shadow: 0 0 15px rgba(0, 102, 204, 0.2);
	border-color: var(--tech-cyan);
}

a {
	color: var(--text-sub);
	text-decoration: none;
	transition: color 0.3s;

	&:hover {
		color: var(--tech-blue);
		text-decoration: underline;
	}
}
</style>